/**
 * Column left — categorieën in sidebar. Na wijziging: npm run build:column-left
 */

export const columnLeftLabels = {
  title: 'Categorieën'
};

export const columnLeftTheme = {
  bg: '#ffffff',
  border: '#e8ecf0',
  titleColor: '#0b3d91',
  linkColor: '#334155',
  linkActiveColor: '#0b3d91',
  linkActiveBg: '#eef4fb',
  childBorder: '#e8ecf0'
};
